export const isMobile = () => {
  if (typeof window !== "undefined") {
    return window.innerWidth < 920;
  }
  return false;
};
